import { Card, Button, Col, Badge, Accordion } from 'react-bootstrap';
import { useState } from 'react';
import PackagingMaterialModal from './PackagingMaterialModal'; // You’ll adapt this for editing

function PackagingMaterialCard({ material, onUpdated }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <Col>
      <Card className="h-100 shadow-sm">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <Card.Title className="mb-1 h2">{material.name}</Card.Title>
              <div className="text-muted">{material.alias}</div>
            </div>
            <Button size="sm" onClick={() => setShowModal(true)}>
              <i className="fa-solid fa-chevron-right"></i>
            </Button>
          </div>

          <hr />

          <p className="mb-1 fs-9"><strong>Dimensions of Packing Material:</strong> {material.size}</p>
          {/* <p className="mb-1 fs-9">
            <strong>Quantity:</strong> {material.quantity} {material.quantityUnit}
            </p> */}
          {/* <p className="mb-1 fs-9">
            <strong>Ideal Weight per Unit:</strong> {material.weightPerBag} {material.weightUnit}
            </p> */}
          <p className="mb-1 fs-9">
            <strong>Weight of the Bag:</strong> {material.weightOfBag} {material.weightOfBagUnit}
          </p>
          <p className="mb-1 fs-9">
            <strong>Reorder Qty:</strong> {material.reorderQuantity} {material.reorderUnit}
          </p>
          <p className="mb-1 fs-9">
            <strong>Lead Time:</strong> {material.leadTimeInDays} days
          </p>
          {material.isOuterPacking ? (
            <>
            <Badge size='sm' bg="secondary" className="mt-2 me-1 text-capitalize">Outer Packing</Badge>
            <Badge bg="secondary" className="mt-2 text-capitalize">Inner/Main Packing</Badge>
            </>
          ) : (
            <Badge bg="secondary" className="mt-2 text-capitalize">Inner/Main Packing</Badge>
          )}

          {material.itemWiseStuffing?.length > 0 && (
            <Accordion className="mt-3" flush>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <strong className="fs-9">Item-wise Stuffing:</strong>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex flex-column gap-1">
                    {material.itemWiseStuffing.map((item, index) => (
                      <div key={index} className="p-2 bg-light rounded fs-9">
                        <i className="fas fa-box-open me-2 text-muted"></i>
                        <strong>{item.product?.productName || 'N/A'}</strong>
                        <span className="ms-1">
                          - {item.quantity} {item.unit || 'kg'}
                        </span>
                      </div>
                    ))}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          )}
        </Card.Body>

        {/* Modal for editing */}
        <PackagingMaterialModal
          show={showModal}
          onHide={() => setShowModal(false)}
          material={material}
          onUpdated={onUpdated}
          isEdit={true}
        />
      </Card>
    </Col>
  );
}

export default PackagingMaterialCard;
